import script from "./email-items.vue?vue&type=script&setup=true&lang=ts"
export * from "./email-items.vue?vue&type=script&setup=true&lang=ts"

import "./email-items.vue?vue&type=style&index=0&id=90a08ea2&lang=scss"

const __exports__ = script;

export default __exports__